import { TrfRem } from 'store/modules/claims/types';
import { CardInfo } from '../../sharedStyles';

import { CardInfoTitleSummary, CardInfoFields } from '../styles';

interface ICardSummary {
  trfRem: TrfRem[];
}

export const Card08 = ({ trfRem }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>TRF/REM</CardInfoTitleSummary>
      <CardInfoFields>
        {trfRem?.map(trf => (
          <>
            <span className="singleLine">Vigência:</span>
            <p className="singleLine">
              {trf.searchDate ? `${trf.searchDate}` : '-'}
            </p>
            <hr />
            <span className="singleLine">TRF:</span>
            <p className="singleLine">
              {trf.pct_taxa_remuneracao_franqueado
                ? `${trf.pct_taxa_remuneracao_franqueado}%`
                : '-'}
            </p>
            <hr />
            <span className="singleLine">REM</span>
            <p className="singleLine">
              {trf.pct_recuperacao_esforco_marketing
                ? `${trf.pct_recuperacao_esforco_marketing}%`
                : '-'}
            </p>
            <hr />
            <span className="singleLine">Alíquota Total:</span>
            <p className="singleLine">
              {trf.pct_total_trf_rem ? `${trf.pct_total_trf_rem}%` : '-'}
            </p>
          </>
        ))}
      </CardInfoFields>
    </CardInfo>
  );
};
